require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// /app/~/angular/index.js
// module id = 2
// module chunks = 0